import React, { useEffect, useRef } from 'react';

const ZapierChatbot = ({ chatbotId = 'cm6ufvzyo000y10x1fp81asqh' }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    // 检查页面上是否已存在 zapier-interfaces-chatbot-embed
    if (document.querySelector('zapier-interfaces-chatbot-embed')) {
      return;
    }

    // 动态插入 script
    const script = document.createElement('script');
    script.type = 'module';
    script.async = true;
    script.src = 'https://interfaces.zapier.com/assets/web-components/zapier-interfaces/zapier-interfaces.esm.js';
    document.body.appendChild(script);

    // 插入自定义标签
    if (containerRef.current) {
      const zapierBot = document.createElement('zapier-interfaces-chatbot-embed');
      zapierBot.setAttribute('is-popup', 'true');
      zapierBot.setAttribute('chatbot-id', chatbotId);
      containerRef.current.appendChild(zapierBot);
    }

    // 清理
    return () => {
      // 只移除当前 containerRef 下的 embed，不移除全局的
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
      // 只移除当前 script
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return <div ref={containerRef}></div>;
};

export default ZapierChatbot;